/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Vendor Requires
require('./vendor/slick.min.js');
require('./vendor/collapse');
require('./vendor/dropdown');
require('./vendor/modal');
require('./vendor/picturefill');
require('./vendor/tab');
require('./vendor/waypoint');
require('./vendor/waypoint-animate');
require('./vendor/js.cookie');

//bootstrap components
//require('bootstrap/js/src/tab');

// App Requires
require('./app/hero');
require('./app/modals');
require('./app/primary-search');
require('./app/primary-navigation');
require('./app/scroll-to');
require('./app/sliders');
require('./app/swiper-sliders');
require('./app/sortby-dropdown');
require('./app/project-board');
require('./app/site-banner');
require('./app/share-popup');
require('./app/filter-toggle');
// require('./app/pdp'); // ecomm disabled
require('./app/newsletter-signup');
require('./app/project-division');
require('./app/user');



$('.qty-control.less').on('click', function (e) {
    e.preventDefault();
    let $input = $(this).next('.quantity').find('input');
    let currentValue = Number($input.val());
    let newValue = currentValue - 1;
    if (currentValue === 1) return;
    $input.val(newValue);
    if (newValue === 1) $(this).addClass('disabled');
});
$('.qty-control.more').on('click', function (e) {
    e.preventDefault();
    let $input = $(this).prev('.quantity').find('input');
    let currentValue = Number($input.val());
    let newValue = currentValue + 1;
    $input.val(newValue);
    $('.qty-control.less').removeClass('disabled');
});
$('#details-toggle').on('click', function (e) {
    e.preventDefault();
    let $targets = $('.product-messages, .product-sharing, .tinvwl-theme-style .tinv-wishlist');
    if ($(this).text() === 'More') {
        $targets.addClass('shown');
        $(this).text('Close');
    } else {
        $targets.removeClass('shown');
        $(this).text('More');
    }
});

require('./app/ada-updates');
